import Phaser from 'phaser';
import { registerCraftingModals } from '../crafting/mode';
import { applySceneRenderBudget } from '../render-budget';
import { hudViewport, updateHudViewport } from '../hud-viewport';
import { createForgeModal } from '../ui/forge-modal';
import { createInventoryModal } from '../ui/inventory-modal';

export class UiScene extends Phaser.Scene {
  private uiRoot!: Phaser.GameObjects.Container;
  forgeModal!: ReturnType<typeof createForgeModal>;
  inventoryModal!: ReturnType<typeof createInventoryModal>;

  constructor() {
    super({ key: 'UiScene' });
  }

  create() {
    applySceneRenderBudget(this);
    this.cameras.main.setScroll(0, 0);

    this.uiRoot = this.add.container(0, 0).setScrollFactor(0).setDepth(150);

    const refreshEquipment = () => {
      const hud = this.game.scene.getScene('HudScene') as { equipmentPanel?: { refresh: () => void } } | null;
      hud?.equipmentPanel?.refresh?.();
    };

    this.forgeModal = createForgeModal(this, () => {
      void this.forgeModal?.refresh?.();
      void this.inventoryModal?.refresh?.();
      refreshEquipment();
    });

    this.inventoryModal = createInventoryModal(this, () => {
      void this.forgeModal?.refresh?.();
      refreshEquipment();
    });

    this.uiRoot.add([this.forgeModal.root, this.inventoryModal.root]);

    registerCraftingModals(this.forgeModal, this.inventoryModal);

    this.game.scale.on('resize', () => this.applyViewportLayout());
    this.applyViewportLayout();
  }

  applyViewportLayout() {
    updateHudViewport(this.game);
    this.uiRoot?.setPosition(hudViewport.x, hudViewport.y);
    this.inventoryModal?.relayout?.();
    this.forgeModal?.relayout?.();
  }
}
